export const ARTICLES_PAGE_THEME = 'orange';

export const ARTICLE_CATEGORY_THEMES = {
    all: 'orange',
    folder: 'purple',
    folderOpen: 'indigo',
};

const LEAF_CATEGORY_THEMES = ['cyan', 'teal', 'success', 'pink', 'info', 'violet', 'warning'];

export const getArticleCategoryTheme = (category, { hasChildren = false, isExpanded = false } = {}) => {
    if (hasChildren) {
        return isExpanded ? ARTICLE_CATEGORY_THEMES.folderOpen : ARTICLE_CATEGORY_THEMES.folder;
    }

    const id = category?.id ?? '';
    let hash = 0;

    for (let i = 0; i < String(id).length; i += 1) {
        hash = String(id).charCodeAt(i) + ((hash << 5) - hash);
    }

    return LEAF_CATEGORY_THEMES[Math.abs(hash) % LEAF_CATEGORY_THEMES.length];
};

export const getArticleCategoryIcon = ({ hasChildren = false, isExpanded = false } = {}) => {
    if (hasChildren) {
        return isExpanded ? 'bi-folder2-open' : 'bi-folder2';
    }

    return 'bi-file-earmark-text';
};
